import { apiService } from './apiService';

export interface DashboardChatUserOption {
  id: string;
  userName: string;
  displayName: string;
}

export interface DashboardChatMessage {
  id: string;
  senderUserId: string;
  senderName: string;
  messageText: string;
  createdAt: string;
  mentionedUserIds: string[];
  isOwnMessage: boolean;
  isMentionedForCurrentUser: boolean;
}

const mapMessage = (item: any): DashboardChatMessage => ({
  id: String(item.id),
  senderUserId: String(item.senderUserId || ''),
  senderName: item.senderName || '',
  messageText: item.messageText || '',
  createdAt: item.createdAt || new Date().toISOString(),
  mentionedUserIds: Array.isArray(item.mentionedUserIds)
    ? item.mentionedUserIds.map((id: any) => String(id))
    : [],
  isOwnMessage: Boolean(item.isOwnMessage),
  isMentionedForCurrentUser: Boolean(item.isMentionedForCurrentUser),
});

const mapUserOption = (item: any): DashboardChatUserOption => ({
  id: String(item.id || ''),
  userName: String(item.userName || ''),
  displayName: String(item.displayName || item.userName || ''),
});

export const dashboardChatService = {
  async getWallMessages(take = 200): Promise<DashboardChatMessage[]> {
    const response = await apiService.get(`/DashboardChat/wall/messages?take=${take}`);
    const data = Array.isArray(response?.data) ? response.data : [];
    return data.map(mapMessage);
  },

  async sendWallMessage(messageText: string): Promise<DashboardChatMessage> {
    const response = await apiService.post('/DashboardChat/wall/messages', { messageText });
    return mapMessage(response?.data);
  },

  async updateWallMessage(messageId: string, messageText: string): Promise<DashboardChatMessage> {
    const response = await apiService.put(`/DashboardChat/wall/messages/${messageId}`, { messageText });
    return mapMessage(response?.data);
  },

  async deleteWallMessage(messageId: string): Promise<void> {
    await apiService.delete(`/DashboardChat/wall/messages/${messageId}`);
  },

  async searchUsers(query: string, take = 10): Promise<DashboardChatUserOption[]> {
    const response = await apiService.get(`/DashboardChat/users/search?query=${encodeURIComponent(query)}&take=${take}`);
    const data = Array.isArray(response?.data) ? response.data : [];
    return data.map(mapUserOption);
  },
};
